import React, { useMemo, useState, useCallback , useEffect} from 'react';
import PageHeader from '../../components/PageHeader';
import api from '../../api';
import useGet from '../../hooks/useGet';
import DataList from '../../components/DataList';
import { getUsersTableConfig } from './tableConfig';
import EmptyTableIndicator from '../../components/EmptyTableIndicator';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import ActionToolbar from '../../components/ActionToolbar';
import AddButton from '../../components/AddButton';
import CreateUserMmodal from './CreateUserMmodal';
import useDelete from '../../hooks/useDelete';
import useUpdate from '../../hooks/useUpdate';
import debounce from 'lodash/debounce';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import useCreate from '../../hooks/useCreate';
import useToggleBlockUser from '../../hooks/useToggleBlockUser';
const PAGE_CONFIG = {
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: 'Administration', link: null },
        { label: 'Users', link: '/users' }
    ],
    PAGE_TITLE: 'Users',
    GET_QUERY_KEY: 'users',
    API_CALL: () => api.users.getUsers(),
    DEFAULT_ERROR_MESSAGE: 'Failed to fetch users',
    SELECT: (data) => data?.data,
    COLUMNS: [
        {
            header: 'Name',
            accessorKey: 'name'
        }
    ]
};
const Users = () => {
    const [params, setParams] = useState({
        page: 1,
        limit: 10,
        search: ''
    });
    const [searchQuery, setSearchQuery] = useState('');
    // Handle page change
    const handlePageChange = (newPage) => {
        if (newPage < 1) return;
        setParams((prev) => ({ ...prev, page: newPage }));
    };

    const handlePageSizeChange = (limit) => {
        if (limit < 1) return;
        setParams((prev) => ({ ...prev, limit }));
    };

   
   
   
    const { data, pagination, isLoading, isError, isSuccess, refetch } = useGet(PAGE_CONFIG.GET_QUERY_KEY, () => api.users.getUsers(params), PAGE_CONFIG.DEFAULT_ERROR_MESSAGE, PAGE_CONFIG.SELECT, PAGE_CONFIG.COLUMNS, params);
    const { deleteItem, isLoading: deleteLoading, deleteDialogProps } = useDelete(PAGE_CONFIG.GET_QUERY_KEY, PAGE_CONFIG.DELETE_API_CALL);
   
    const { update, status: updateStatus, updateDialogProps } = useUpdate(PAGE_CONFIG.GET_QUERY_KEY, PAGE_CONFIG.UPDATE_API_CALL, PAGE_CONFIG.UPDATE_SUCCESS_MESSAGE, PAGE_CONFIG.UPDATE_ERROR_MESSAGE);
  
//   Hook to toggle block user
    const { toggleBlockUser, isTogglingBlock } = useToggleBlockUser();

    
    const handleEdit = useCallback((item) => update(item), [update]);
    const handleDelete = useCallback((id) => deleteItem(id), [deleteItem]);
    const handleDownload = useCallback((id) => console.log('download', id), []);
    const handleEnableUser = useCallback((id) => toggleBlockUser(id), [toggleBlockUser]);
    const handleDisableUser = useCallback((id) => toggleBlockUser(id), [toggleBlockUser]);

    const columns = useMemo(() => getUsersTableConfig(handleEdit, handleDelete, handleEnableUser, handleDisableUser), [handleEdit, handleDelete, handleEnableUser, handleDisableUser]);
    const { create, status: createStatus, createDialogProps } = useCreate('users', (data)=> api.users.createUser(data), 'User created successfully', 'User creation failed');

 
 console.log('data', data);
    // Create a debounced search function
    const debouncedSearch = useMemo(
        () =>
            debounce((searchValue) => {
                setParams((prev) => ({ ...prev, search: searchValue, page: 1 }));
            }, 500),
        []
    );

    // Cleanup debounce on component unmount
    useEffect(() => {
        return () => debouncedSearch.cancel();
    }, [debouncedSearch]);

    // Trigger refetch when params change
    useEffect(() => {
        refetch();
    }, [params, refetch]);

    const handleSearch = (value) => {
        setSearchQuery(value);
        debouncedSearch(value);
    };

    const AddUserButton = (
        <AddButton
            isLoading={false}
            onClick={() => {
                createDialogProps?.setIsOpen(true);
            }}
            label={'Add User'}
        />
    );

    return (
        <div className="flex">
            <div className="flex-1 min-h-screen">
                <PageHeader items={PAGE_CONFIG.BREADCRUMB} pageTitle={PAGE_CONFIG.PAGE_TITLE} />
                <ActionToolbar searchQuery={searchQuery} onSearchChange={handleSearch} actionButton={AddUserButton} disabled={false} />
                {data?.length > 0 ? (
                    <DataList data={data} columns={columns} pagination={pagination} />
                ) : (
                    <EmptyTableIndicator colSpan={5} isLoading={isLoading} icon={faSearch} description="Search for a user by name, email, or phone number" placeholder="Search User" loadingMessage="Loading..." />
                )}
                <CreateUserMmodal {...createDialogProps} status={createStatus} isEdit={false} setIsEdit={() => false} onSubmit={create} />
                <ConfirmationDialog isLoading={deleteLoading} {...deleteDialogProps} />
                <CreateUserMmodal {...updateDialogProps} status={updateStatus} isEdit={true} setIsEdit={() => false} onSubmit={update} />
            </div>
        </div>
    );
};

export default Users;
